export default "__VITE_ASSET__Cw9Iy$qs__"